module.exports = __webpack_public_path__ + "static/img/item1.e0fa814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/item1.png
// module id = Ep/H
// module chunks = 0